// generated by the plop

import { PaginatorModel, PROGRESS_STATUSES } from 'symbols';
import { TalonModel } from '../../symbols';

export interface TalonListStateModel {
  talonList: PaginatorModel<TalonModel>;
  loadTalonListStatus: PROGRESS_STATUSES;
  lastOpenedDocId: string;
  scrollPosition: number;
}

export const TALON_LIST_STATE_DEFAULT: TalonListStateModel = {
  talonList: {
    data: [],
    meta: null,
    links: null
  },
  loadTalonListStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  lastOpenedDocId: null,
  scrollPosition: 0
};
